import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import Button from '../../components/atoms/Buttons'
import { UPDATE_BOOKING } from '../../apollo/mutations/booking'
import './style.css'

const EditBookingDetailsModal = ({ booking, onClose, onDone }) => {
  const [form, setForm] = useState({
    customerName: booking.customerName || '',
    customerEmail: booking.customerEmail || '',
    customerPhone: booking.customerPhone || '',
    notes: booking.notes || '',
  })
  const [errorText, setErrorText] = useState('')
  const [updateBooking, { loading: saving }] = useMutation(UPDATE_BOOKING, {
    refetchQueries: ['listBookingsByDate'],
  })

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  const submit = async (e) => {
    e.preventDefault()
    try {
      await updateBooking({
        variables: {
          id: booking.id,
          input: {
            customerName: form.customerName,
            customerEmail: form.customerEmail,
            customerPhone: form.customerPhone || null,
            notes: form.notes || null,
          },
        },
      })
      onDone?.()
    } catch (err) {
      setErrorText(err?.message || 'Could not save changes.')
    }
  }

  const field = 'booking-form-field'
  const label = 'booking-form-label'

  return (
    <div>
      <div className="booking-modal-backdrop" onClick={onClose} />
      <form onSubmit={submit} className="booking-modal-container" style={{ maxWidth: 480, width: '92%' }}>
        <h2 className="add-events !text-[28px] !mt-0 mb-4">Edit Booking</h2>
        <div className="space-y-4">
          <div>
            <div className={label}>Customer Name</div>
            <input className={field} value={form.customerName} onChange={set('customerName')} />
          </div>
          <div>
            <div className={label}>Email</div>
            <input type="email" className={field} value={form.customerEmail} onChange={set('customerEmail')} />
          </div>
          <div>
            <div className={label}>Phone</div>
            <input className={field} value={form.customerPhone} onChange={set('customerPhone')} />
          </div>
          <div>
            <div className={label}>Notes</div>
            <textarea className={field + ' !h-[90px] py-2'} value={form.notes} onChange={set('notes')} />
          </div>
          {errorText && <div className="text-[13px] text-[color:var(--color-primary-danger)]">{errorText}</div>}
          <div className="flex gap-x-3 mt-2 justify-center">
            <Button type="submit" loading={saving} primary>
              Save Changes
            </Button>
            <Button type="button" onClick={onClose} primaryOutline>
              Cancel
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EditBookingDetailsModal
